import React from "react";

import { navigate } from "@reach/router";

import Message from "./modals/Message";
import Modal from "./modals/Modal";
import Config from "../config";
import calcsStandaloneScreenshot from "../assets/images/Calcs - standalone screenshot.png";
import lpCopyIcon from "../assets/images/lpCopy_icon.svg";
import lpEditIcon from "../assets/images/lpEdit_icon.svg";
import lpPriceUpdateIcon from "../assets/images/lpPriceUpdate_icon.svg";
import lpTemplateIcon from "../assets/images/lpTemplate_icon.svg";
import fetchFromApi from "../utils/fetchFromApi";

class GettingStarted extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      error: false,
      errorDetails: false,
      success: false,
      newTemplateName: "",
    };
  }
  componentDidMount = async () => {
    document.title = `Getting Started ${Config.titleSuffix}`;
  };

  async completeOnboarding() {
    localStorage.setItem("isOnboarding", "complete");

    if (this.props.onboarding) {
      const path = "/onboarding/complete";
      const options = {
        method: "POST",
      };

      await fetchFromApi(path, this.props.location.pathname, options);
    }
  }

  async createTemplate() {
    try {
      this.setState({ loading: true });

      const path = "/template/create";
      const options = {
        method: "POST",
        body: JSON.stringify({
          name: "Template 1",
        }),
      };

      const response = await fetchFromApi(
        path,
        this.props.location.pathname,
        options,
      );

      if (this.props.onboarding) {
        localStorage.setItem("isOnboarding", "complete");
      }

      navigate("/template/" + response.id + "?newTemplate=true");
    } catch (error) {
      console.log(error);
      this.setState({
        loading: false,
        error: true,
        errorDetails: {
          title: "Could not create Template",
          message:
            typeof error === "string"
              ? error
              : "We were unable to create your template. Please try again.",
        },
      });
    }
  }

  async getStarted() {
    try {
      this.setState({ loading: true });
      await this.completeOnboarding();
      navigate("/tools");
    } catch (error) {
      console.log(error);
      this.setState({
        loading: false,
        error: true,
        errorDetails: {
          title: "Could not complete onboarding",
          message: "Please try again.",
        },
      });
    }
  }

  async bookOnboardingCall() {
    try {
      this.setState({ loading: true });
      await this.completeOnboarding();
      window.location.href =
        "https://meetings.hubspot.com/hbevan/linepilot-book-onboarding";
    } catch (error) {
      console.log(error);
      this.setState({
        loading: false,
        error: true,
        errorDetails: {
          title: "Could not complete onboarding",
          message: "Please try again.",
        },
      });
    }
  }

  render() {
    return (
      <div className="flex flex-col items-center w-full max-w-5xl my-6">
        <Message open={this.state.loading} type="loading" title="Loading..." />
        <Modal
          open={this.state?.error}
          type="error"
          title={this.state.errorDetails.title}
          message={this.state.errorDetails.message}
          setClose={() => {
            this.setState({ error: false }),
              setTimeout(() => this.setState({ errorDetails: false }), 500);
          }}
        />

        <div className="mb-6 text-center">
          <h1 className="mb-1 text-4xl text-tone-900">
            Explore LinePilot features...
          </h1>
          <p className="mt-2 font-semibold text-md">
            Not sure what tools to choose?{" "}
            <button
              className="p-0 font-semibold text-md button-link"
              onClick={() => this.bookOnboardingCall()}
            >
              Book an onboarding call
            </button>
          </p>
        </div>

        <div className="grid w-full grid-cols-1 gap-4 md:grid-cols-2 xl:gap-8">
          <div className="flex flex-col items-center p-8 bg-white card">
            <div className="flex items-center w-full gap-4">
              <img src={lpTemplateIcon} alt="" className="w-16 h-16" />
              <h2 className="m-0 text-2xl text-primary">Templates</h2>
            </div>
            <p className="mt-4 text-md">
              Easy to use, no-code tool for generating line items
            </p>

            <div className="flex flex-col items-center flex-1 w-full mt-6">
              <ul className="flex flex-col w-full gap-4 text-sm font-semibold">
                <li className="flex items-start gap-3">
                  <span className="mt-2 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-primary"></span>
                  <span>Create line items on deals automatically</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="mt-2 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-primary"></span>
                  <span>
                    Use calculations or deal properties to populate values
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="mt-2 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-primary"></span>
                  <span>Show and hide line items with conditions</span>
                </li>
              </ul>
              <div className="flex items-center justify-center w-full h-24 my-4">
                <img
                  src={calcsStandaloneScreenshot}
                  alt=""
                  className="object-contain max-w-full max-h-full"
                />
              </div>
            </div>
            <button
              className="justify-center w-full mt-8 rounded-md button-primary"
              onClick={() => this.createTemplate()}
            >
              Create a Template
            </button>
          </div>

          <div className="flex flex-col p-8 bg-white card">
            <h2 className="w-full m-0 mb-4 text-2xl text-primary">Tools</h2>
            <p className="mt-2">
              Workflow actions to help you automate line item operations
            </p>
            <div className="flex flex-col flex-1 gap-8 mt-4">
              <div className="flex items-center gap-4">
                <img src={lpEditIcon} alt="" className="w-16 h-16" />
                <div>
                  <h3 className="text-base font-semibold">Edit line items</h3>
                  <p className="mt-1 text-xs">
                    Bulk edit multiple line items on a deal. Just choose the
                    property you&apos;d like to update and the new value.
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <img src={lpCopyIcon} alt="" className="w-16 h-16" />
                <div>
                  <h3 className="text-base font-semibold">Copy line items</h3>
                  <p className="mt-1 text-xs">
                    Automatically copy line items from one deal to another.
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <img src={lpPriceUpdateIcon} alt="" className="w-16 h-16" />
                <div>
                  <h3 className="text-base font-semibold">
                    Change line item pricing
                  </h3>
                  <p className="mt-1 text-xs">
                    Apply a percentage increase or decrease to the prices of the
                    line items on your deal.
                  </p>
                </div>
              </div>
            </div>
            <button
              className="justify-center w-full mt-8 rounded-md button-primary"
              onClick={() => this.getStarted()}
            >
              Get Started
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default GettingStarted;
